import { useHasSalesSupport, useIsBechtle, useIsDustin, useIsMobit, useProfile } from '@/hooks/user'

const useBetaAccess = () => {
  const profile = useProfile()
  const userName = profile?.username ?? ''
  const hasTradeInAccess = profile?.isTradeInDealer ?? false
  const isBechtle = useIsBechtle()
  const isMobit = useIsMobit()
  const isDustin = useIsDustin()
  const hasSalesSupport = useHasSalesSupport()

  const isFullBetaUser = ['1 tcm ordre', 'oddy-dealer'].includes(userName.toLowerCase())
  const hasShop = !isBechtle
  const hasOrders = !isBechtle
  const hasCustomers = !isBechtle
  const hasCreditCheck = false
  const hasCreditRequest = isBechtle
  const hasDeviceOrderToEcom = isFullBetaUser || isMobit || isDustin
  const hasInjuryReports = !isBechtle

  return {
    isFullBetaUser,
    hasCustomers,
    hasShop,
    hasOrders,
    hasCreditCheck,
    hasCreditRequest,
    hasDeviceOrderToEcom,
    hasInjuryReports,
    hasSalesSupport,
    hasTradeInAccess,
  }
}

export default useBetaAccess
